export enum VcoSipHeaderTag {
  VCO_TYPE_PREF = '0035',
  VCO_ACTIVE = '0036',
}
